// extracted by mini-css-extract-plugin
export default {"youtubeEmbedContainer":"DqVH_","youtubeMargins":"FC19s"};